import React from 'react';

import CartButton from '../../shared/components/cart-button';
import Button from '../../ui/components/button';

import '../css/modal-footer-v2.less';

const ModalFooterV2 = ({ closeModal, backBtnText='back', backBtnMobileText='keep shopping', cartBtnText='go to cart', cartBtnMobileText='go to cart', device }) => (
    <div className='modal-footer'>
        <div className='btn-container'>
            <Button 
                onClick={closeModal} 
                text={device === 'mobile' ? backBtnMobileText : backBtnText} 
                action={'back'} 
                type={'tertiary'} 
                className='continue-shopping' 
            />
            <CartButton 
                buttonText={device === 'mobile' ? cartBtnMobileText : cartBtnText} 
                className='two-up-modal-v2' 
                useAnimatedBtn={true} 
            />
        </div>
    </div>
)

export default ModalFooterV2;
